<template style="height: 100%;">
  <div class="Useraddmore">
    <div class="Useraddmore_div"
      v-loading="loading"
      element-loading-text="保存中..."
      element-loading-spinner="el-icon-loading"
      width="30%;"
    >
      <div class="up_template">
        <el-upload
          drag
          :limit="limitNum"
          :on-remove="handleRemove"
          :auto-upload="false"
          accept=".xls,.xlsx"
          :action="UploadUrl()"
          :before-upload="beforeUploadFile"
          :on-change="fileChange"
          :on-exceed="exceedFile"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="fileList"
          ref="upload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ $t('original.languages28') }}
            <em>{{ $t('original.languages29') }}</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            {{ $t('original.languages27') }}
          </div>
        </el-upload>
      </div>
      <el-button style="margin-left: 20px;" type="primary" @click="uploadFile">
        {{ $t('original.languages23') }}
      </el-button>
      <el-button type="primary" @click="down_template">{{ $t('original.languages24') }}</el-button>

      <div v-if="pd" class="hugl">
        <el-table :data="tableData" style="width: 100%;" max-height="500">
          <el-table-column
            prop="Line"
            :label="$t('original.languages35')"
            width="120"
          ></el-table-column>

          <el-table-column
            fixed
            prop="Message"
            :label="$t('original.languages36')"
            width="500"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [],
      deleteRow(index, rows) {
        rows.splice(index, 1)
      },
      tableData: [],
      pd: false,
      loading: false,
    }
  },
  methods: {
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${
          files.length + fileList.length
        } 个`,
      )
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList.push(file.raw)
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      let size = file.size / 1024 / 1024
      if (extension !== 'xlsx,xls') {
        this.$message.warning(this.$t('original.languages30'))
      }
      if (size > 10) {
        this.$message.warning(this.$t('original.languages31'))
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success(this.$t('original.languages32'))
    },
    handleRemove() {
      this.$refs.upload.clearFiles()
      this.fileList = []
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error(this.$t('original.languages33'))
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return ''
    },
    extraData() {
      return {
        name: this.form.name,
        version: this.form.version,
        type: this.form.type,
      }
    },
    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message.warning(this.$t('original.languages34'))
      } else {
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
        var fd = new FormData()
        fd.append('file', this.fileList[0])
        this.loading = true
        this.$Http_Post('User/UploadFile', fd, {'Content-Type': 'multipart/form-data'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loading = false;
            this.Global.request_successful(res.Message);
            this.pd = false;
          } else if (res.Code == 500) {
            this.loading = false;
            this.Global.request_failure(res.Message);
            this.tableData = res.Data;
            this.pd = true;
          }
        })
      }
    },
    down_template() {
      window.location.replace(
        process.env.VUE_APP_URL + 'File/TemplateFile/用户导入.xls',
      )
    },
  },
}
</script>
<style>
.Useraddmore .down_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  float: left;
}
.Useraddmore .up_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  float: left;
  margin-left: 20px;
}
.el-dialog__footer {
  text-align: center;
  margin-top: 110px;
}
.Useraddmore .el-upload-dragger .el-upload__text {
  color: #606266;
  font-size: 14px;
  text-align: center;
  margin-top: -20px;
}
.Useraddmore .el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 9px 0 16px;
  line-height: 50px;
}
.Useraddmore .el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 220px;
  height: 118px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.Useraddmore .el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: -32px;
  width: 466px;
  text-align: left;
}
.Useraddmore .el-upload-list__item:first-child {
  margin-top: -19px;
}
.Useraddmore .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.Useraddmore_div {
  height: 100%;
}
.Useraddmore {
  height: 680px;
}
.Useraddmore .hugl {
  width: 100%;
  height: 460px;
  margin-top: 180px;
}
</style>
